import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchCons } from 'Redux/Admin/DecisionManager/Cons/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { ICon } from 'Redux/Admin/DecisionManager/Cons/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<ICon> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/decision-manager/cons/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Context',
    dataIndex: 'context',
    key: 'context',
    width: 280,
  },
  {
    title: 'Option-Criteria',
    dataIndex: 'option_criteria',
    key: 'option_criteria',
    width: 120,
  },
];

const Cons = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const optionCriterion = params.get('option-criterion');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchCons);

  useEffect(() => {
    dispatch(fetchCons({ option_criteria: optionCriterion, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [optionCriterion, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'option-criterion-select',
      paramName: 'option-criterion',
      placeholder: 'Select option-criterion...',
      label: 'Option Criterion'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<ICon>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/decision-manager/cons/new`}
      filters={filterConfigs}
    />
  );
}

export default Cons;
